
document.addEventListener("DOMContentLoaded", () => {
  // Configuração do Intersection Observer para as animações de Scroll
  const observerOptions = {
    threshold: 0.1, // Dispara quando 10% do elemento está visível
    rootMargin: "0px 0px -50px 0px" // Dispara um pouco antes de aparecer totalmente
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // Anima apenas uma vez ao descer
      }
    });
  }, observerOptions);

  // Aplica o observer em todos os elementos com a classe motion-reveal
  const revealElements = document.querySelectorAll('.motion-reveal');
  revealElements.forEach(el => observer.observe(el));
});
